// 按北京日期（YYYY-MM-DD，D174）筛选的页面用：余额详情（docs/04 第 4 节，D99）。营收数据与成本报表 D197 起改用时间范围选择器。
import { beijingDay } from "@/ui";

/** 含今天的近 N 个北京日：起始日期是今天减 N−1。 */
export function recentDays(days: number, now = new Date()): { from: string; to: string } {
  return { from: beijingDay(new Date(now.getTime() - (days - 1) * 86_400_000)), to: beijingDay(now) };
}

/** from 到 to 含两端的日数。to 晚于今天时先截到今天，与服务端 dayRangeOf 一致；from 晚于截断后的 to 时小于 1。 */
export function daySpan(from: string, to: string, today = beijingDay(new Date())): number {
  return Math.round((Date.parse(to > today ? today : to) - Date.parse(from)) / 86_400_000) + 1;
}
